import React, {useState} from "react";
import styled from "styled-components/macro";
import {device} from "../device";
import {keyframes} from "styled-components";
import {ReactComponent as ToolTipImg} from "../../images/clipboardToolTip.svg";
import {getStorage, ref} from "firebase/storage";

const storage = getStorage();

const Elevate = ({buildingName}) => {
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        if (copiedUrl) {
            setTimeout(() => {
                setCopiedUrl(false);
            }, 12000);
        }
    }, [copiedUrl]);
    return (
        <Wrapper>
            <SubTitle marginBottom={"50px"}>
                Whether a residence, a business, or student housing, we’re equipped to
                meet the widest range of potential consumers.
            </SubTitle>

            <div style={{display: "flex", flexDirection: "row"}}>
                {copiedUrl && (
                    <>
                        <ToolTip>
                            <ToolTipImg style={{width: "100%", height: "100%"}}/>
                        </ToolTip>
                        <ToolTipText>Copied To Clipboard </ToolTipText>
                    </>
                )}
                <Button
                    id="eventCopyLink"
                    onClick={() => {
                        navigator.clipboard.writeText(window.location.href);
                        setCopiedUrl(true);
                    }}
                >
                    Share File
                </Button>
                <ButtonPDF
                    id="eventDownloadPDF"
                    onClick={async () => {
                        setLoading(true);
                        try {
                            const gsReference = ref(storage, "gs://tulu-push.appspot.com/proposals/" + buildingName + ".pdf");

                            const downloadurl = await gsReference.getDownloadURL();
                            // window.open(downloadurl);

                            // This can be downloaded directly:
                            var xhr = new XMLHttpRequest();
                            xhr.responseType = "blob";
                            xhr.onload = (event) => {
                                var blob = xhr.response;
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement("a");
                                a.style.display = "none";
                                a.href = url;
                                // the filename you want

                                a.download = `${buildingName}.pdf`;
                                document.body.appendChild(a);
                                a.click();
                                window.URL.revokeObjectURL(url);
                            };
                            xhr.open("GET", downloadurl);
                            xhr.send();
                        } catch (err) {
                            console.log(err);
                        } finally {
                            setLoading(false);
                        }
                    }}
                >
                    {" "}
                    {loading ? <span>Downloading PDF...</span> : `Download PDF`}
                </ButtonPDF>
            </div>
        </Wrapper>
    );
};

export {Elevate};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  color: white;
  font-family: "DMSans", serif;
  background-color: #12637a;
  @media ${device.mobileS} {
    padding: 30px 58px 35px 29px;
  }
  @media ${device.tablet} {
    padding: 100px;
  }
`;

const SubTitle = styled.span`
  @media ${device.mobileS} {
    font-size: 15px;
    margin-bottom: ${({marginBottom}) => 25 || 0}px;
  }
  @media ${device.tablet} {
    margin-bottom: ${({marginBottom}) => marginBottom || 0}px;
    font-size: 20px;
    max-width: 800px;
  }
`;
const Button = styled.button`
  cursor: pointer;
  border-radius: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: white;
  @media ${device.mobileS} {
    margin-right: 20px;
    font-size: 12px;
    width: 150px;
    height: 32px;
    border: solid 1px #fff;
    font-size: 15px;
  }
  @media ${device.tablet} {
    border: solid 3px #fff;
    height: 65px;
    margin: 10px 39px 0 3px;
    width: 320px;
    font-size: 20px;
  }
`;

const ButtonPDF = styled(Button)`
  @media ${device.mobileS} {
    display: none;
  }
  @media ${device.tablet} {
    display: block;
  }
`;

const fade = keyframes`
  0% {
    opacity: 0;
  }

  5% {
    opacity: 1;
  }

  95% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }


`;

const ToolTip = styled.div`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  animation: ${fade} 8s;
  @media ${device.mobileS} {
    width: 134.5px;
    height: 36.8px;
    left: 70px;
    bottom: 11px;
  }
  @media ${device.tablet} {
    height: 64.7px;
    width: 266px;
    left: 220px;
    bottom: 55px;
  }
`;

const ToolTipText = styled.div`
  position: absolute;
  opacity: 0;
  pointer-events: none;

  color: black;
  text-align: center;
  animation: ${fade} 8s;
  @media ${device.mobileS} {
    width: 112.4px;
    height: 30.6px;
    font-size: 10px;
    left: 80px;
    bottom: 2px;
  }
  @media ${device.tablet} {
    height: 64.7px;
    width: 266px;
    font-size: 20px;
    left: 220px;
    bottom: 30px;
  }
`;
